import { createContext } from "react";
import { AppHeaderContextType } from "./AppHeaderContextTypes";


export const AppHeaderContext = createContext<AppHeaderContextType | undefined>(undefined);
